import * as components from "../sections";

import styles from "./styles/home.module.scss";

export default function () {
  return (
    <>
      {components.LayoutWrapper(
        <>
          <div className={styles.wrapper}>
            <components.HeroSection className={styles.section} />
            <components.MaskSection className={styles.section} />
            <components.MobileAppSection className={styles.section} />
            <components.NewsSection />
            <components.ContacUsSection className={styles.section} />
            <components.FooterSection className={styles.footerSection} />
          </div>
        </>
      )}
    </>
  );
}
